import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input[type="checkbox"] {
    pointer-events: auto;
    z-index: 10;
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  div.checkmark {
    height: 18px;
    width: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #0e4c54;
    border-radius: 2px;
    margin-right: 0.6em;
    transition: background-color 0.3s ease, border-color 0.3s ease;

    div {
      height: 10px;
      width: 10px;
      background-color: transparent;
      display: none;
      position: relative;

      &.checked {
        display: block;
        background-color: #0e4c54;
      }

      &.checked::after {
        content: "✓";
        position: absolute;
        color: white;
        font-size: 10px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  input:checked ~ div.checkmark {
    border-color: #0e4c54;
    background-color: #0e4c54;
  }

  input:checked ~ div.checkmark div.checked {
    background-color: transparent;
  }
`;
